export type FinancialData = {
  pending: number
  lastClosedOut: number
  receivableMilestone: number
}

const DEFAULT_FINANCIAL_DATA: FinancialData = {
  pending: 0,
  lastClosedOut: 0,
  receivableMilestone: 0,
}

// Every sign-in/join entry point receives this same shape from GET /users/:id
// profile response. Building it here once keeps the shape and fallback in
// sync across all of them.
export const buildFinancialData = (
  raw?: Partial<FinancialData>
): FinancialData => ({
  pending: Number(raw?.pending) || DEFAULT_FINANCIAL_DATA.pending,
  lastClosedOut:
    Number(raw?.lastClosedOut) || DEFAULT_FINANCIAL_DATA.lastClosedOut,
  receivableMilestone:
    Number(raw?.receivableMilestone) ||
    DEFAULT_FINANCIAL_DATA.receivableMilestone,
})
